import { toolKitConstants } from '../ChapterPage/communityCommon.constant';

export const ForumLinks = {
    FIND_A_CFF: 'https://www.blackqard.com/categories/facilitators?organization=ypo-forum',
    FIND_A_RETREAT: 'https://www.blackqard.com/categories/facilitated-retreats?organization=ypo-forum',
    MODERATING_MATERIALS: `https://${process.env.VUE_APP_ENVIRONMENT}.ypowpo.org/portal/department/forum/toolkit/materials`,
    JOINING_FORUM: `https://${process.env.VUE_APP_ENVIRONMENT}.ypowpo.org/portal/department/forum/pages/join`,
    ABOUT_FORUM: `https://${process.env.VUE_APP_ENVIRONMENT}.ypowpo.org/portal/department/forum/pages/about`,
};

export const ForumLinkTexts = {
    FIND_A_CFF: 'CFF Resource Directory',
    FIND_A_RETREAT: 'Find a Retreat',
    MODERATING_MATERIALS: 'Officer and Moderator Materials',
    JOINING_FORUM: 'Joining a Forum',
    ABOUT_FORUM: 'About Forum',
    SEE_MORE: 'See More',
    SEARCH: 'Search...',
    SAMPLE_AGENDAS: 'Sample Forms and Agendas',
    CONTRIBUTED_BY: 'Contributed by:',
};
export const FORUM_LINKS_REMOVED = ['Find a Retreat'];

export const ConfidentialityReminder = {
    Header_Texts: {
        NOTHING: 'NOTHING',
        NOBODY: 'NOBODY',
        NEVER: 'NEVER',
        NOT_SELECTIVE: 'Not Selective',
        FOREVER: 'Forever',
        MUTUAL_AGREEMENT: 'A Mutual Agreement',
    },

    TITLE: 'CONFIDENTIALITY REMINDER',

    BUTTON: 'All In',

    Description: {
        NOT_SELECTIVE:
            'Members may not share anything discussed in forum with anyone outside of the forum. (“Nothing, Nobody, Never.”)',
        FOREVER: 'It does not expire when the member leaves the forum or YPO.',
        MUTUAL_AGREEMENT:
            'All members must agree to respect the confidentiality of information shared in forum. YPO encourages all forums to have a signed confidentiality agreement that is reviewed annually. Further, just because I tell you something is “Forum Confidential” doesn’t mean it is. You must agree to hold the information to that level of confidence.',
    },
};

export const addTagsAndImages = (data) => {
    const newforumToolKitList = [];
    data.map((item) => {
            newforumToolKitList.push({
                name: item.name,
                id: item.id,
                tag: item.keywords,
                img: item.typeIcons,
            });
        return newforumToolKitList;
    });
    return newforumToolKitList;
};

export const mapConstants = {
    CREATE_MEETING: 'Create New Meeting',
    CHOOSE_LOCATION: 'Choose Location',
    DONE: 'Done',
    BACK: 'Back',
};

export const makeForumToolkitObjects = (data) => {
    const obj = {
        name: '',
        timeRange: [toolKitConstants.MIN_RANGE, toolKitConstants.MAX_RANGE],
        topic: 'All',
        materials: '',
    };
    const states = [];
    if (data && data.length > 0) {
        data.forEach((item) => {
            const state = Object.assign({}, obj);
            state.name = item.name;
            states.push(state);
        });
    }
    return states;
};
